import { CompressionType } from '../../planogram/models/product-group';
import { IProductPacking } from './product-card';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

export interface IProductConf {
	stand: number;
	shelf_no: number;
	number: number;
	element_id: string;
	qty: number;
	master_product: number;
	rotation: string;
	position_x: number;
	position_y: number;
	position_z: number;
	placement_depth: number;
	placement_height: number;
	packing: number;
	applied_compressions: Array<CompressionType>;
	height_compression_coef: number;
	width_compression_coef: number;
	depth_compression_coef: number;
	depend_product: number;
	error_product: any;
	weight: number;
	availability: boolean;
	angle: number;
}

export interface IProductCard {
	article: string;
	barcode: string;
	brand_names: string;
	category_paths: string;
	depth: number;
	depth_compression_coef: number;
	description: string;
	height: number;
	height_compression_coef: number;
	id: number;
	is_loose: boolean;
	is_master_position: boolean;
	master_positions: Array<{ url: string; name: string }>;
	marker_paths: string;
	name: string;
	packing: Array<IProductPacking>;
	photo: string;
	price: number;
	stock_qty: number;
	supplier_names: string;
	width: number;
	width_compression_coef: number;
	is_archived: boolean;
	set_compression_to_global_everywhere?: boolean;
}

export interface IShowProductCard {
	key?: number;
	name?: string;
	createParams?: number;
	tab?: ProductCardTab;
}

export interface IProductGeneralInfo {
	is_master_position: boolean;
	is_archived: boolean;
}

export interface ICloseProductCard {
	force: boolean;
}

export enum ProductChangeTypes {
	Loose = 'CHANGE_IS_LOOSE',
	Params = 'CHANGE_SIZES',
	Compression = 'COMPRESSION_COEF',
	Image = 'CHANGE_PHOTO',
	ChangePacking = 'CHANGE_PACKING',
	DeletePacking = 'DELETE_PACKING',
	NewPacking = 'NEW_PACKING',
	Products = 'CHANGE_PRODUCTS',
	Description = 'CHANGE_DESCRIPTION',
	Article = 'CHANGE_ARTICLE',
	Name = 'CHANGE_NAME',
	Archive = 'ARCHIVE_PRODUCT'
}

export interface IProductHistoryTableItem {
	created_at: string;
	expanded_children: Array<IProductHistoryChild>;
	key: number;
	source: string;
	type: string;
}

export interface IProductHistoryChild {
	id: number;
	type: string;
	params: {
		depth?: HistoryProperty;
		width?: HistoryProperty;
		height?: HistoryProperty;
		photo?: HistoryProperty;
		qty?: HistoryProperty;
		depth_compression_coef?: HistoryProperty;
		height_compression_coef?: HistoryProperty;
		width_compression_coef?: HistoryProperty;
	}
}

export interface ISearchSettings {
	title: string;
	name: string;
	selected: boolean;
}

export interface ISearchRotation {
	searchFromSettings: Array<ISearchSettings>;
	searchToSettings: Array<ISearchSettings>;
}

export interface ISyncProductMessage {
	current: number;
	full_name: string;
	is_sync: boolean;
	products: Array<number>;
	total: number;
	user_id: number;
}

export interface IUpdatedParams {
	id: number;
	height: number;
	width: number;
	depth: number;
}

export interface IProductCardParams {
	shop_id?: number
}

export interface ICompressionParams {
	width_compression_coef: number;
	height_compression_coef: number;
	depth_compression_coef: number;
}

export enum AssortmentType {
	NONE = 'NONE',
	TEST = 'DEFAULT',
	OWN = 'OWN_DATA'
}

export interface IAssortmentType {
	assortment_type: AssortmentType
}

export interface IProductCardForm {
	is_loose: FormControl<boolean>;
	photo: FormControl<string>;
	height: FormControl<number>;
	width: FormControl<number>;
	depth: FormControl<number>;
	width_compression_coef: FormControl<number>;
	height_compression_coef: FormControl<number>;
	depth_compression_coef: FormControl<number>;
	set_compression_to_global_everywhere: FormControl<boolean>;
	packing: FormArray<FormGroup<IProductCardPackingForm>>;
	name?: FormControl<string>;
	article?: FormControl<string>;
	description?: FormControl<string>;
	enableHeightCompression?: FormControl<boolean>;
	enableWidthCompression?: FormControl<boolean>;
	enableDepthCompression?: FormControl<boolean>;
}

export interface IProductCardPackingForm {
	id: FormControl<number>;
	name: FormControl<string>;
	qty: FormControl<number>;
	weight: FormControl<number>;
	height: FormControl<number>;
	width: FormControl<number>;
	depth: FormControl<number>;
	photo: FormControl<string>;
	color: FormControl<string>;
	position: FormControl<number>;
}

type HistoryProperty = {
	from: string | number | null;
	to: string | number | null;
}

export interface IGeneralInfoField {
	name: string;
	value: string;
}

export interface IParamsField {
	name: string;
	label: string;
	value?: number;
	enableName?: string;
}

export enum ProductTypes {
	Product = 'product',
	MasterPosition = 'master_position'
}

export enum ProductCardTab {
	Params = 'params',
	MasterProducts = 'masterProducts',
	Layout = 'layout',
	History = 'history'
}

export interface ISaveProducts {
	id: number;
	products: MPProductsPayload;
}

export interface IMPProductsItem {
	product: number;
	position: number;
}

export interface IUpdateProductPosition {
	id: number | string;
	position: number;
}

export type MPProductsPayload = Array<IMPProductsItem>;

export const MAX_MP_PRIORITY_VALUE: number = 9999;

// TODO: need type to proeucts requests params